import { createFileRoute } from '@tanstack/react-router';

import { readJobCardName } from '../../features/job-cards/breadcrumb-data';
import { JobCardDetailPage } from '../../features/job-cards/job-card-detail-page';

export const Route = createFileRoute('/job-cards/$jobCardId')({
  staticData: {
    // Resolve the Job Card's name from the cached detail response so the trail
    // reads "Job Cards > {job card}" rather than the raw UUID Legacy showed.
    // Returns null until the detail page's query has populated the cache.
    breadcrumb: (match, queryClient) => {
      const { jobCardId } = match.params as { jobCardId: string };
      return readJobCardName(queryClient, jobCardId);
    },
    // Deliberately NOT 'full-height'. That layout gives fixed chrome the space it
    // asks for and lets one fill region scroll — which only works while the chrome
    // fits the viewport. This panel runs to five sections above the tabs, so the
    // fill region collapsed to nothing and the tab content became unreachable.
    // The page scrolls as a whole instead; the Checks grid inside already bounds
    // its own height.
  },
  component: JobCardDetailRoute,
});

function JobCardDetailRoute() {
  const { jobCardId } = Route.useParams();
  return <JobCardDetailPage jobCardId={jobCardId} />;
}
